export default "__VITE_PUBLIC_ASSET__88340fb7__"